<template>
  <div class="c-app flex-row align-items-center login-page bg-shadow">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <validation-observer tag="form" ref="form">
                  <h1>Dakland</h1>
                  <p class="text-muted">Đăng nhập vào hệ thống quản lý</p>
                  <b-alert
                    fade class="mb-0"
                    :show="dismissCountDown"
                    variant="secondary"
                    @dismissed="dismissCountDown=0"
                    @dismiss-count-down="countDownChanged"
                    style="display: none !important;"
                  ></b-alert>
                  <validation-provider name="Tài khoản" rules="required" v-slot="{valid, errors}">
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <CIcon name="cil-user"/>
                          <sup class="mt-2 text-star-validate">*</sup>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input v-model="username" placeholder="Tài khoản"
                                    :state="!valid && errors[0] ? valid : null"
                                    aria-describedby="input-username"
                                    autocomplete="off" autofocus
                                    @keydown.enter="loginAction"
                                    @input="onChangeInput">
                      </b-form-input>
                      <b-form-invalid-feedback id="input-username">{{ errors[0] }}</b-form-invalid-feedback>
                    </b-input-group>
                  </validation-provider>
                  <validation-provider name="Mật khẩu" rules="required" v-slot="{valid, errors}">
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <CIcon name="cil-lock-locked"/>
                          <sup class="mt-2 text-star-validate">*</sup>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input v-model="password" placeholder="Mật khẩu"
                                    :state="!valid && errors[0] ? valid : null" aria-describedby="input-password"
                                    type="password" autocomplete="curent-password"
                                    @keydown.enter="loginAction"
                                    @input="onChangeInput">
                      </b-form-input>
                      <b-form-invalid-feedback id="input-password">{{ errors[0] }}</b-form-invalid-feedback>
                    </b-input-group>
                  </validation-provider>
                  <CRow>
                    <CCol col="12">
                      <b-form-checkbox v-model="remember" @change="rememberAccount">Ghi nhớ tài khoản</b-form-checkbox>
                    </CCol>
                  </CRow>
                  <hr/>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton color="danger" class="px-4" v-b-modal="'cc-modal-center'">Quên mật khẩu?</CButton>
                    </CCol>
                    <CCol col="6" class="text-right">
                      <CButton color="success" class="px-4" @click="loginAction">Đăng nhập</CButton>
                    </CCol>
                  </CRow>
                </validation-observer>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
    <cc-modal title="Quên mật khẩu" size="lg" @onShowModal="onShowModal">
      <template slot="body">
        <p class="text-muted">Nhập tài khoản của bạn</p>
        <validation-observer tag="form" ref="formUsernameResetPass" onsubmit="return false">
          <validation-provider name="Tài khoản" rules="required" v-slot="{valid, errors}">
            <CRow>
              <CCol>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <CIcon name="cil-user"/>
                      <sup class="mt-2 text-star-validate">*</sup>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input v-model="usernameResetPass" placeholder="Tài khoản"
                                :state="!valid && errors[0] ? valid : null"
                                aria-describedby="input-username-reset-pass"
                                autocomplete="off"
                                :disabled="verifyCodeData && verifyCodeData.timeout > 0"
                                @keydown.enter.prevent="getVerifyCode"></b-form-input>
                  <b-input-group-append>
                    <CButton color="primary" class="px-3"
                             :disabled="!usernameResetPass.length || (verifyCodeData && verifyCodeData.timeout > 0)"
                             @click="getVerifyCode">
                      <b-spinner v-if="verifyCodeData && verifyCodeData.timeout > 0" small
                                 label="Loading with countdown" class="mr-1"></b-spinner>
                      {{ verifyCodeData && verifyCodeData.timeout > 0 ? `Thử lại sau ${dismissCountDown}s` : 'Lấy mã xác thực' }}
                    </CButton>
                  </b-input-group-append>
                  <b-form-invalid-feedback id="input-username-reset-pass">{{ errors[0] }}</b-form-invalid-feedback>
                </b-input-group>
              </CCol>
            </CRow>
          </validation-provider>
        </validation-observer>
        <validation-observer tag="form" ref="formVerifyCode">
          <CRow v-if="dismissCountDown > 0">
            <CCol>
              <CRow>
                <CCol>
                  <validation-provider name="Mã xác thực" rules="required|digits:6" v-slot="{valid, errors}">
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <CIcon name="cil-stream"/>
                          <sup class="mt-2 text-star-validate">*</sup>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input v-model="verifyCode" placeholder="Mã xác thực"
                                    :state="!valid && errors[0] ? valid : null"
                                    aria-describedby="input-verify-code"
                                    autocomplete="off"
                                    :disabled="dismissCountDown === 0"
                                    @keydown.enter.prevent="onVerifyCode"></b-form-input>
                      <b-form-invalid-feedback id="input-verify-code">{{ errors[0] }}</b-form-invalid-feedback>
                    </b-input-group>
                  </validation-provider>
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <b-alert
                    fade class="mb-0"
                    :show="dismissCountDown"
                    variant="secondary"
                    @dismissed="dismissCountDown=0"
                    @dismiss-count-down="countDownChanged"
                  >
                    <p class="text-dark">
                      Đã gửi mã xác thực về email: <b class="text-success">{{ verifyCodeData && verifyCodeData.message.split(' ')[4].split(',')[0] }}</b>
                    </p>
                    <b-progress
                      variant="danger"
                      :max="dismissSecs"
                      :value="dismissCountDown"
                      height="4px"
                    ></b-progress>
                  </b-alert>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </validation-observer>
      </template>
      <template slot="footer">
        <div class="w-100 text-right">
          <CButton color="success" class="px-3 mr-2"
                   :disabled="!(dismissCountDown && verifyCode && verifyCode.length === 6)"
                   @click="onVerifyCode">
            Xác thực
          </CButton>
          <CButton color="secondary" class="px-3" @click="closeModal">Đóng</CButton>
        </div>
      </template>
    </cc-modal>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {SHOW_TOAST_2} from '@/common/lib'
import {mapActions} from 'vuex'
import CcModal from '@/components/common/CcModal'
import {forgetPassword} from '@/mixins/forgetPassword/forgetPassword'

export default {
  name: 'Login',
  components: {
    ValidationObserver,
    ValidationProvider,
    CcModal
  },
  mixins: [
    forgetPassword
  ],
  data() {
    return {
      username: '',
      password: '',
      remember: false
    }
  },
  async created() {
    if (!this.$cookies.isKey('userInfo')) {
      if (Object.keys(this.$route.params).length && (this.$route.params.pathName !== '/auth/login' && this.$route.params.pathName !== '/auth/change-password')) {
        if (Object.keys(this.$route.query).length && this.$route.query.isExpired) {
          SHOW_TOAST_2('warning', 'Phiên đăng nhập hết hạn. Vui lòng đăng nhập lại!')
        }
      }
    } else {
      await this.getLoginFormLocalstorage()
      this.onChangeInput()
    }
  },
  methods: {
    ...mapActions('auth', ['userLogin']),
    ...mapActions('user', ['getUserDetail']),
    async loginAction() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        const formData = {
          name: this.username,
          password: this.password,
        }
        const res = await this.userLogin(formData)
        console.log('loginAction', res)
        if (res) {
          localStorage.removeItem('getVerifyCodeData')
          SHOW_TOAST_2('success', 'Đăng nhập thành công.')
          this.getUserDetail().then(async () => {
            await this.$router.push({name: 'Home'})
          })
        } else {
          SHOW_TOAST_2('error', 'Đăng nhập thất bại.')
        }
      }
    },
    rememberAccount(value) {
      if (value) {
        const _loginForm = {
          isRemember: value,
          username: this.username,
          password: btoa(`${Math.floor(Math.random() * 100000000000000000)}<>${this.password}<>${Math.floor(Math.random() * 100000000000000000)}!@#$%^&*()-=+`)
        }
        localStorage.setItem('loginForm', JSON.stringify(_loginForm))
      } else {
        localStorage.removeItem('loginForm')
      }
    },
    onChangeInput() {
      this.rememberAccount(this.remember)
    },
    getLoginFormLocalstorage() {
      const _isLoginFormLocalstorage = Object.prototype.hasOwnProperty.call(localStorage, 'loginForm')
      if (_isLoginFormLocalstorage) {
        const _loginForm = JSON.parse(localStorage.getItem('loginForm'))
        this.username = _loginForm['username']
        this.password = atob(_loginForm['password']).split('<>')[1]
        this.remember = _loginForm['isRemember']
      }
    }
  }
}
</script>
